import React from "react";

function RamsActivity() {
  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-start gap-3 flex-wrap mb-3">
        <div>
          <h2 className="mb-1">RAMS Activities</h2>
          <p className="text-muted mb-0">
            Placeholder page for future RAMS activities workflows.
          </p>
        </div>
      </div>

      <div className="alert alert-info mb-0" role="alert">
        This section is reserved for RAMS Activities submenus and data views.
      </div>
    </div>
  );
}

export default RamsActivity;
